/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'video': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M849.5 962h-675C108.216 962 62 915.784 62 849.5v-675C62 108.216 108.216 62 174.5 62h675C915.784 62 962 108.216 962 174.5v675c0 66.284-46.216 112.5-112.5 112.5zm-750-750v75h150l-72.858-182.135C130.023 118.397 99.5 158.387 99.5 212zm150-112.5L324.501 287h112.481L362 99.5H249.5zm187.482 0L512 287h112.5l-75-187.5H436.981zm187.518 0l75 187.5H812L737 99.5H624.5zm300 112.5c0-66.284-46.216-112.5-112.5-112.5L887.001 287H924.5v-75zm0 112.5H99.501V812c0 66.284 46.216 112.5 112.5 112.5h600c66.284 0 112.5-46.216 112.5-112.5V324.5zM362 437l337.5 187.5L362 812V437.001z"/>'
  }
})
